import React from 'react'
import AirlineCheckInTypeItem from './AirlineCheckInTypeItem'
import SearchField from './SearchField'

export default ({
  airlines = [],
  onAirlineSelect,
  filterText,
  onFilterTextChange,
}) => (
  <div className="flex flex-col h-full">
    <div className="mb-4">
      <SearchField
        value={filterText}
        onChange={onFilterTextChange}
        placeholder="Search airlines..."
      />
    </div>
    <div className="flex-1 overflow-y-auto">
      {renderAirlineItems(airlines, onAirlineSelect)}
    </div>
  </div>
)

const renderAirlineItems = (airlines, onAirlineSelect) => {
  if (airlines.length <= 0)
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <svg
          className="w-16 h-16 text-gray-300 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
          />
        </svg>
        <h3 className="text-gray-900 font-medium text-lg mb-1">
          No airlines found
        </h3>
        <p className="text-gray-500 text-sm">
          Try adjusting your search criteria
        </p>
      </div>
    )
  return airlines.map((airline) => (
    <AirlineCheckInTypeItem
      key={airline.id}
      airline={airline}
      onClick={onAirlineSelect}
    />
  ))
}
